import styled from "styled-components";
import Location from "./Location";
import Folder from "./Folder";
import PREV_SVG from "assets/images/prev.svg";
import { folder } from "shared/types/Report";
import { hw, scrollbar } from "../homeworkUi";

interface FolderAction {
    id: number;
    name: string;
    icon: string;
}

interface FolderViewProps{
    folderList:{
        id:string,
        name:string,
        type:string
    }[],
    onFolderClick:(folder:folder) => void,
    onPrevClickHandler:() => void,
    onSelectClickHandler?:(id:string, value:boolean) => void,
    onSelectAllClickHandler?:(value:boolean) => void,
    nowFolder:string,
    selectedReport:string,
    selectedFolderList?:string[],
    actions?: FolderAction[],
    onActionClick?: (id: number) => void,
}

const FolderView = ({folderList, nowFolder, selectedReport, onFolderClick, onPrevClickHandler, onSelectClickHandler, onSelectAllClickHandler, selectedFolderList, actions, onActionClick}:FolderViewProps) => {
    const viewFolderList = () => {
        if(!folderList.length){
            return <Empty>폴더가 비어 있습니다</Empty>;
        }
        return folderList.map((item, index)=> {
            return <Folder key={index + 1} folder={item} onFolderClick={onFolderClick} selectedReport={selectedReport} onSelectClickHandler={onSelectClickHandler} selectedList={selectedFolderList}/>
        })
    }

    return(
        <Container>
            <Location nowFolder={nowFolder} selectedReport={selectedReport}/>
            {actions && onActionClick ? (
                <ActionGrid>
                    {actions.map((item) => (
                        <ActionButton
                            key={item.id}
                            type="button"
                            $danger={item.id === 4}
                            onClick={() => onActionClick(item.id)}
                        >
                            <ActionIcon src={item.icon} alt="" />
                            {item.name}
                        </ActionButton>
                    ))}
                </ActionGrid>
            ) : null}
            <Contents>
                <Header>
                    <ButtonWrap type="button" onClick={onPrevClickHandler}>
                        <ButtonIcon src={PREV_SVG} alt="" />
                        <ButtonName>뒤로가기</ButtonName>
                    </ButtonWrap>
                    {onSelectAllClickHandler ? (
                        <SelectAllWrap>
                            <SelectAllLabel htmlFor="selectAll">전체선택</SelectAllLabel>
                            <SelectAllCheckBox id="selectAll" type="checkbox" onChange={(e) => onSelectAllClickHandler(e.target.checked)}/>
                        </SelectAllWrap>
                    ) : null}
                </Header>
                <FolderListWrapper>
                    {viewFolderList()}
                </FolderListWrapper>
            </Contents>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    height: 100%;
    background: ${hw.surface};
    padding: 16px;
`;

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 4px 10px;
    border-bottom: 1px solid ${hw.border};
`;

const Contents = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
`;

const FolderListWrapper = styled.div`
    flex: 1;
    overflow-y: auto;
    margin-top: 8px;
    min-height: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
    ${scrollbar}
`;

const ButtonIcon = styled.img`
    width: 16px;
    height: 16px;
`;

const ButtonWrap = styled.button`
    appearance: none;
    border: none;
    background: transparent;
    display: flex;
    gap: 6px;
    align-items: center;
    cursor: pointer;
    padding: 6px 8px;
    border-radius: ${hw.radiusSm};
    transition: background 0.15s ease;

    &:hover {
        background: ${hw.bg};
    }
`;

const ButtonName = styled.span`
    color: ${hw.text};
    font-size: 13px;
    font-weight: 600;
`;

const SelectAllWrap = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
`;

const SelectAllLabel = styled.label`
    color: ${hw.textMuted};
    font-size: 13px;
    font-weight: 500;
`;

const SelectAllCheckBox = styled.input`
    width: 16px;
    height: 16px;
    margin: 0;
    accent-color: ${hw.brand};
    cursor: pointer;
`;

const Empty = styled.div`
    padding: 32px 12px;
    text-align: center;
    color: ${hw.textSubtle};
    font-size: 13px;
`;

const ActionGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 6px;
`;

const ActionButton = styled.button<{ $danger?: boolean }>`
    appearance: none;
    border: 1px solid ${props => props.$danger ? hw.brandMuted : hw.border};
    background: ${props => props.$danger ? hw.brandSoft : hw.surface};
    color: ${props => props.$danger ? hw.brand : hw.text};
    border-radius: ${hw.radiusSm};
    padding: 8px 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: -0.02em;
    transition: background 0.15s ease, border-color 0.15s ease;

    &:hover {
        background: ${props => props.$danger ? hw.brandMuted : hw.bg};
        border-color: ${props => props.$danger ? hw.brand : "#CBD5E1"};
    }
`;

const ActionIcon = styled.img`
    width: 14px;
    height: 14px;
    opacity: 0.9;
    filter: brightness(0) saturate(100%);
`;

export default FolderView;
